import $ from "jquery";
// import SimpleBar from 'simplebar';
import SimpleScrollbar from 'simple-scrollbar'
import 'slick-carousel';

var map = null;
var popup = null;
var simplebar = null;
var isZoomed = true;
var activeId = 0;

export function loadMap() {

    if (typeof window.buildings == 'undefined') isZoomed = false;
    popup = new mapboxgl.Popup({closeButton: false});

    mapboxgl.accessToken = 'pk.eyJ1IjoiYnNjLXEiLCJhIjoiY2s5YTJhcGFnMDRwczNmcDdxaHplamhtaiJ9._CdFdnIblazLxMWczSZC-A';

    map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/bsc-q/ck9iket8014if1inmclrz507f',
        center: [11.5795, 48.1455],
        zoom: isZoomed ? 18 : 16,
        minZoom: 16,
        maxZoom: 18,
        scrollZoom: false,
        doubleClickZoom: false,
        dragRotate: false,
        keyboard: false,
        touchZoomRotate: false,
        antialias: true,
        maxBounds: isZoomed ? [[11.572009873478805,48.14355126679504],[11.587782091037752,48.148072767079896]] : [[11.55108469346601,48.13896748146806], [11.607180235756118,48.15390629088057]]
    });


    map.on('style.load', function () {

        addMainBuilding();

        if (isZoomed) addBuildings();
        if (!isZoomed) addMarkers();
 
        map.on('mousemove', function(e) {
            document.getElementById('info').value = e.lngLat.wrap().lng + ',' + e.lngLat.wrap().lat;
        }).on('click', function(e) {
            document.getElementById('info').value = e.lngLat.wrap().lng + ',' + e.lngLat.wrap().lat;
            document.getElementById('info').select();
            document.execCommand("copy");
        });

        startGallery();
        simplebar = SimpleScrollbar.initEl(document.querySelector('.mappage-innerwrapper'));

        $('.mappage-wrapper-pin').on('click', function() {
            toggleSidebar();
        });

        map.on('click', function(e) {
            var isBuilding = false;
            $.each(map.queryRenderedFeatures(e.point), function(index, el) {
                if (el.layer.id == 'buildings') isBuilding = true;
                if (el.layer.id == 'main-building' && !isZoomed) isBuilding = true;
                if (el.layer.id == 'markers') isBuilding = true;
            });
            if (isBuilding) return;
            toggleSidebar('close');
        });

        $('body').on('click', '.mappage-list a', function(e) {

            e.preventDefault();
            var url = $(this).attr('href');
            var params = setActiveState(url);

            if (params != false) {
                history.pushState({url: params.url, icon: params.icon, title: params.title, seotitle: params.seotitle, id: params.id}, params.title, params.url);
                document.title = params.seotitle;
                loadShop(params.url, params.icon);
            }

        }).on('mousemove', '.mappage-list a', function(e) {

            e.preventDefault();
            var url = $(this).attr('href');
            var features = isZoomed ? window.buildings : window.markers;
            var params = {};

            $.each(features, function() {
                if (this.properties.url == url) {
                    params = this.properties;
                }
            });

            if (Object.keys(params).length) {
                map.setFeatureState(
                { source: isZoomed ? 'buildings' : 'markers', id: params.id },
                { hover: true }
                );
            }

        }).on('mouseenter', '.mappage-list a', function(e) {

            var url = $(this).attr('href');
            var features = isZoomed ? window.buildings : window.markers;
            var geometry = {};

            $.each(features, function() {
                if (this.properties.url == url) {
                    geometry = this.geometry;
                }
            });
            if (geometry.type == 'Point') {
                map.easeTo({center: geometry.coordinates});
            }

        }).on('mouseleave', '.mappage-list a', function(e) {

            e.preventDefault();
            var url = $(this).attr('href');
            var features = isZoomed ? window.buildings : window.markers;
            var params = {};

            $.each(features, function() {
                if (this.properties.url == url) {
                    params = this.properties;
                }
            });

            if (Object.keys(params).length) {
                map.setFeatureState(
                { source: isZoomed ? 'buildings' : 'markers', id: params.id },
                { hover: false }
                );
            }
        });

        $('.mappage-btn').on('click', function(e) {

            e.preventDefault();

            var title = $(this).attr('data-title');
            var url = $(this).attr('href');

            history.pushState({}, title, url);
            document.title = title;

            map.setFeatureState(
            { source: isZoomed ? 'buildings' : 'markers', id: activeId },
            { active: false }
            );

            loadShop(url);
            $('.mappage-btn').fadeOut();

        });

        $(window).on('popstate', (e) => {
            var params = e.originalEvent.state;
            if (typeof params == 'undefined' || params == null || !Object.keys(params).length) params = null;

            map.setFeatureState(
            { source: isZoomed ? 'buildings' : 'markers', id: activeId },
            { active: false }
            );

            activeId = null;

            if (params != null) {

                activeId = params.id;
                
                map.setFeatureState(
                { source: isZoomed ? 'buildings' : 'markers', id: params.id },
                { active: true }
                );

                var features = isZoomed ? window.buildings : window.markers;
                var geometry = {};

                $.each(features, function() {
                    if (this.properties.id == activeId) {
                        geometry = this.geometry;
                    }
                });
                if (geometry.type == 'Point') {
                    map.easeTo({center: geometry.coordinates});
                }

                document.title = params.seotitle;
                loadShop(params.url, params.icon);
            }

            if (params == null && isZoomed) {
                loadShop('/shops');
                $('.mappage-btn').fadeOut();
                return;
            }

            if (params == null && !isZoomed) {
                loadShop('/lage');
                $('.mappage-btn').fadeOut();
                return;
            }
        });
    });

    map.on('load', (e) => {

        if (history.state) {
            var params = history.state;

            activeId = params.id;

            if (typeof activeId != 'undefined') { 
                map.setFeatureState(
                { source: isZoomed ? 'buildings' : 'markers', id: params.id },
                { active: true }
                );
            }
        } else {
            var params = setActiveState(location.href);
            if (params != false) {
                history.replaceState({url: params.url, icon: params.icon, title: params.title, seotitle: params.seotitle, id: params.id}, params.title, params.url);
            }
        }
    });
};

function addMainBuilding() {

    map.addSource('main-building', {
        'type': 'geojson',
        'data': {
            'type': 'FeatureCollection',
            'features': window.buildingCoordinates
        }
    });

    map.addLayer({
        'id': 'main-building',
        'type': 'fill',
        'source': 'main-building',
        'layout': {},
        'paint': {
            'fill-color': isZoomed ? '#f39998' : '#e73331'
        }
    });

    map.addLayer({
        'id': 'main-building-lines',
        'type': 'line',
        'source': 'main-building',
        'layout': {},
        'paint': {
            'line-color': '#000',
            'line-width': 1
        }
    });

    map.on('mousemove', 'main-building', function(e) {
        if (!isZoomed) {

            map.getCanvas().style.cursor = 'pointer';

            popup
            .setLngLat(e.lngLat)
            .setHTML('<h3>Das Ludwigpalais</h3>')
            .addTo(map);
        }
    }).on('mouseleave', 'main-building', function() {
        if (!isZoomed) {
            map.getCanvas().style.cursor = '';
            popup.remove();
        }
    }).on('click', 'main-building', function() {
        if (!isZoomed) window.location = $('.mappage-btn').prop('href');
    });
}

function addBuildings() {

    var hoveredStateId = null;

    map.addSource('buildings', {
        'type': 'geojson',
        'data': {
            'type': 'FeatureCollection',
            'features': window.buildings
        }
    });

    map.addLayer({
        'id': 'buildings',
        'type': 'fill',
        'source': 'buildings',
        'layout': {},
        'paint': {
            'fill-color': [
                'case', ['boolean', ['feature-state', 'active'], false], '#000000', [
                    'case', ['boolean', ['feature-state', 'hover'], false], '#ed6665', '#e73331'
                ]
            ]
        }
    });

    map.addLayer({
        'id': 'buildings-lines',
        'type': 'line',
        'source': 'buildings',
        'layout': {},
        'paint': {
            'line-color': '#000',
            'line-width': $(window).width() > 1020 ? 3 : 2
        }
    });

    map.on('mousemove', 'buildings', function(e) {
        if (e.features.length > 0) {
            if (hoveredStateId) {
                map.setFeatureState(
                { source: 'buildings', id: hoveredStateId },
                { hover: false }
                );
                if (isZoomed) {
                    popup.setLngLat(e.lngLat)
                    .setHTML('<h4 class="u-nomargin">'+e.features[0].properties.category+'</h4><div class="separator"></div><h3 class="u-nomargin">'+e.features[0].properties.title+'</h3>')
                    .addTo(map);
                }
            } else {
                popup.remove();
            }
            hoveredStateId = e.features[0].id;
            map.setFeatureState(
                { source: 'buildings', id: hoveredStateId },
                { hover: true }
            );
        }
    }).on('mouseleave', 'buildings', function() {
        if (hoveredStateId) {
            map.setFeatureState(
            { source: 'buildings', id: hoveredStateId },
            { hover: false }
            );
        }
        popup.remove();
        hoveredStateId = null;
    }).on('click', 'buildings', function(e) {

        if (!isZoomed) return;

        var params = e.features[0].properties;

        map.setFeatureState(
        { source: isZoomed ? 'buildings' : 'markers', id: activeId },
        { active: false }
        );

        activeId = params.id;
        
        map.setFeatureState(
        { source: isZoomed ? 'buildings' : 'markers', id: params.id },
        { active: true }
        );

        history.pushState({url: params.url, icon: params.icon, title: params.title, seotitle: params.seotitle, id: params.id}, params.title, params.url);
        document.title = params.seotitle;
        loadShop(params.url, params.icon);

        // DEBUG: auch unter _mappage.scss
        // popup.setLngLat(e.lngLat)
        // .setHTML('<h3>'+e.features[0].properties.title+'</h3>')
        // .addTo(map);

    }).on('mouseenter', 'buildings', function() {
        if (isZoomed) map.getCanvas().style.cursor = 'pointer';
    }).on('mouseleave', 'buildings', function() {
        if (isZoomed) map.getCanvas().style.cursor = '';
    });
}

function addMarkers() {

    var hoveredStateId = null;

    map.loadImage(window.location.origin+"/assets/images/marker2.png", function(error, image) {
        if (error) {
            console.log(error);
            return;
        }
        map.addImage("custom-marker", image);
        /* Style layer: A style layer ties together the source and image and specifies how they are displayed on the map. */
        map.addLayer({
            id: "markers",
            type: "symbol",
            /* Source: A data source specifies the geographic coordinate where the image marker gets placed. */
            source: {
                type: "geojson",
                data: {
                    type: 'FeatureCollection',
                    features: window.markers
                }
            },
            layout: {
                'icon-image': 'custom-marker'
            },
            paint: {
                'icon-opacity': [
                    'case', ['boolean', ['feature-state', 'active'], false], 1, [
                        'case', ['boolean', ['feature-state', 'hover'], false], 1, 0.55
                    ]
                ]
            }
        });
    });
    

    map.on('mousemove', 'markers', function(e) {
        if (e.features.length > 0) {
            if (hoveredStateId) {
                map.setFeatureState(
                { source: 'markers', id: hoveredStateId },
                { hover: false }
                );
            }
            hoveredStateId = e.features[0].id;
            map.setFeatureState(
                { source: 'markers', id: hoveredStateId },
                { hover: true }
            );
        }
    }).on('mouseenter', 'markers', function(e) {

        map.getCanvas().style.cursor = 'pointer';

        popup
        .setLngLat(e.features[0].geometry.coordinates.slice())
        .setHTML('<h3>'+e.features[0].properties.title+'</h3><div class="separator"></div><h4>'+e.features[0].properties.category+'</h4>')
        .addTo(map);

    }).on('mouseleave', 'markers', function() {
        if (hoveredStateId) {
            map.setFeatureState(
            { source: 'markers', id: hoveredStateId },
            { hover: false }
            );
        }
        map.getCanvas().style.cursor = '';
        popup.remove();
    }).on('click', 'markers', (e) => {

        var params = e.features[0].properties;
        var geometry = e.features[0].geometry;

        map.setFeatureState(
        { source: isZoomed ? 'buildings' : 'markers', id: activeId },
        { active: false }
        );

        activeId = params.id;
        
        map.setFeatureState(
        { source: isZoomed ? 'buildings' : 'markers', id: params.id },
        { active: true }
        );

        if (geometry.type == 'Point') {
            map.easeTo({center: geometry.coordinates});
        }

        history.pushState({url: params.url, icon: params.icon, title: params.title, seotitle: params.seotitle, id: params.id}, params.title, params.url);
        document.title = params.seotitle;
        loadShop(params.url, params.icon);

    });
}

function toggleSidebar(action = 'toggle') {

    $('.mappage').removeClass('mappage--hidden');

    if (action == 'close') {
        $('.mappage').addClass('mappage--closed');
    } else if (action == 'open') {
        $('.mappage').removeClass('mappage--closed');
    } else if (action == 'toggle') {
        $('.mappage').toggleClass('mappage--closed');
    }

    var resizing = setInterval(function() {
        map.resize();
    },5);
    setTimeout(function() {
        // map.flyTo({center: [11.5795, 48.1455]});
        clearInterval(resizing);
    }, 1000);
    return;
}

function loadShop(url, icon = window.location.origin+'/assets/images/logo-small.svg') {

    var $wrapper = $('.mappage-innerwrapper');
    var $loader = $('.mappage-wrapper-loader');
    var $content = $('.mappage-wrapper-content');

    if (url.match(/\/shops\//)) {
        $('.mappage').addClass('mappage--bigshop');
        $('.mappage-btn').fadeIn();
    } else if (url.match(/\/lage\//)) {
        $('.mappage-btn').fadeIn();
    } else {
        $('.mappage').removeClass('mappage--bigshop');
        $('.mappage-btn').fadeOut();
    }

    $content.data('animationend', false);

    $wrapper.css('overflow-y', 'hidden');
    toggleSidebar('open');
    if (icon) $loader.load(icon);

    $loader.fadeIn(function() {

        $content.html('').load(url + ' #content > div', {}, function() {

            if ($content.data('animationend')) $content.trigger('shop.loaded');

        }).one('shop.loaded', function() {

            startGallery();
            // simplebar.recalculate();
            // console.log(simplebar);

            $loader.fadeOut(function() {
                $wrapper.css('overflow-y', 'auto');
            });

            $content.data('animationend', false);
        });

    }).css('display','flex');

    setTimeout(function() {
        $content.data('animationend', true).trigger('shop.loaded');
    }, 2000);

}

function startGallery() {
    if ($('.mappage-gallery').children().length) $('.mappage-gallery').slick({dots:true});
}

function setActiveState(url) {

    var features = isZoomed ? window.buildings : window.markers;
    var params = {};
    var geometry = {};

    $.each(features, function() {
        if (this.properties.url == url) {
            params = this.properties;
            geometry = this.geometry;
        }
    });

    if (activeId) {
        map.setFeatureState(
        { source: isZoomed ? 'buildings' : 'markers', id: activeId },
        { active: false }
        );
    }

    activeId = params.id;

    if (activeId) {
    
        map.setFeatureState(
        { source: isZoomed ? 'buildings' : 'markers', id: params.id },
        { active: true }
        );

        if (geometry.type == 'Point') {
            map.easeTo({center: geometry.coordinates});
        }

        return params;
    }

    return false;
    
}
